module.exports = __webpack_public_path__ + "img/10_2.5c375c14.png";